import React, { useState, useEffect } from 'react';

import './styles.css';

import studentsServices from '../../../../../services/academy/studentsServices';

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import SelectGroup from '../../../../../components/SelectGroup';
import Notice from '../../../../../components/Notice';
import { FaUsers, FaSearch } from 'react-icons/fa';

function PopupNewStudent(props) {
    const [searchName, setSearchName] = useState('')
    const [selectList, setSelectList] = useState([]);
    const [hideList, setHideList] = useState([]);
    // const [students, setStudents] = useState([]);

    useEffect(() => {
        if (props.students)
            setHideList(props.students.map((item, index) => item.user.ativo ? -1 : index).filter((item) => item !== -1));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.students]);

    async function updateStudentClass() {
        if (props.students && (props.students[selectList[0]].turma == null || props.students[selectList[0]].turma.id !== props.classId)) {
            const response = await studentsServices.patchStudentClass(props.students[selectList[0]].id, props.classId);
            if (response.status === 200) {
                setTimeout(() => {
                    props.onDelete(selectList[0]);
                    setSelectList([]);
                }, 500);
                props.onUpdate();
                props.setVisibility(false);
            } else
                alert("Erro ao atualizar turma do aluno, tente novamente!");
        } else
            alert("O aluno já está inscrito nessa turma.");
    };

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaUsers />}
            tittle='Alunos'
        >
            {
                props.students.length ?
                    <>
                        <form>
                            <div className='line'>
                                <Input
                                    hideLabel
                                    placeholder="Busque pelo nome do aluno"
                                    placeholderIcon={<FaSearch />}
                                    id='class-new-student-search'
                                    onChange={(event) => setSearchName(event.target.value)}
                                    value={searchName}
                                />
                            </div>
                        </form>
                        <SelectGroup
                            single

                            hides={hideList}
                            markeds={selectList}
                            setMarkeds={setSelectList}
                        >
                            {
                                props.students.filter((item) => `${item.nome} ${item.sobrenome}`.toLowerCase().includes(searchName.toLowerCase())).map((item, index) =>
                                    <div key={item.id} className='popup-new-student-select-group-item'>
                                        {
                                            item.foto ?
                                                <img src={item.foto} alt="foto de usuário" />
                                                :
                                                <div className='user-photo' />
                                        }
                                        <p><b>{`${item.nome} ${item.sobrenome}`}</b></p>
                                        <span className={"tag small " + (item.user.ativo ? "green" : "red")}>
                                            {item.user.ativo ? "Ativo" : "Inativo"}
                                        </span>
                                    </div>
                                )
                            }
                        </SelectGroup>
                        <button type='button' onClick={updateStudentClass}>Inscrever na turma</button>
                    </>
                    : <Notice>Não há alunos disponíveis para inscrição nessa turma</Notice>
            }
        </Popup>
    )
}

export default PopupNewStudent;